module.exports = __webpack_public_path__ + "static/media/background_modal_robo.6f9a98ff.svg";